import { Badge, Button, Card, Input, message, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { MdAdd } from 'react-icons/md';
import { Link, useHistory } from 'react-router-dom';
import Layout from '../../components/Layout';
import api from '../../services/api';

import { Container } from './styles';

interface LifeArea {
  _id: string;
  name: string;
  color: string;
  description: string;
  quadrant: {
    name: string;
  };
}

const LifeAreas: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [lifeAreas, setLifeAreas] = useState<LifeArea[]>([]);

  const history = useHistory();

  useEffect(() => {
    async function loadData(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get('lifeAreas');

        setLifeAreas(response.data);
      } catch (err) {
        message.error('Erro ao carregar dados');
      } finally {
        setLoading(false);
      }
    }

    loadData();
  }, []);

  if (loading) {
    return (
      <Layout title="Áreas da Vida">
        <Spin style={{ marginTop: '50%' }} size="large" />
      </Layout>
    );
  }

  return (
    <Layout title="Áreas da Vida">
      <Container>
        <h2>Gerenciamento de Áreas da Vida</h2>

        <div id="controls">
          <Button
            icon={<MdAdd />}
            size="large"
            onClick={() => history.push('/lifeAreas/add')}
          >
            Adicionar
          </Button>

          <Input.Search
            placeholder="Pesquisar"
            size="large"
            style={{ maxWidth: 290 }}
          />
        </div>

        <div className="lifeareas-grid">
          {lifeAreas.map(lifeArea => (
            <Link key={lifeArea._id} to={`/lifeAreas/${lifeArea._id}`}>
              <Card
                className="card"
                style={{ width: 300 }}
                // eslint-disable-next-line prettier/prettier
                title={
                  <Badge
                    color={lifeArea.color || 'cyan'}
                    text={lifeArea.name}
                  />
                  // eslint-disable-next-line prettier/prettier
                }
                extra={lifeArea.quadrant.name}
              >
                <p>{lifeArea.description}</p>
              </Card>
            </Link>
          ))}
        </div>
      </Container>
    </Layout>
  );
};

export default LifeAreas;
